/** ***
 * RSA加密解密工具类
 * **/
import { JSEncrypt } from 'jsencrypt' // 导入
// 公钥和私钥需前后端一致
// 公钥
//const publicKey = ''
// 私钥
//const privateKey = '获取的私钥'

// 加密
export function encrypt(data,publicKey) {
    const encryptor = new JSEncrypt()
    encryptor.setPublicKey(publicKey) // 设置公钥
    return encryptor.encrypt(data) // 对需要加密的数据进行加密
}

// 解密
export function decrypt(data,privateKey) {
    const encryptor = new JSEncrypt()
    encryptor.setPrivateKey(privateKey)
    return encryptor.decrypt(data)
}
